import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LinePlusIcon from 'components/Luxkit/Icons/line/LinePlusIcon'
import Heading from 'components/Luxkit/Typography/Heading'
import TextButton from 'components/Luxkit/Button/TextButton'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'

const HeaderContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 10fr 1fr;
  height: ${rem(60)};
  padding: 0 ${rem(24)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};


  ${mediaQueryUp.tablet} {
    grid-template-columns: 0fr 10fr 1fr;
  }

  ${mediaQueryDown.mobile} {
    padding-left: 0;
  }
`

const StyledHeader = styled.div`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-column: 1 / span 2;
  }
`

const StyledMenu = styled.div`
  display: grid;
  justify-content: right;
`

interface HeaderProps {
  onNewChatClick?: () => void;
}

function Header({
  onNewChatClick,
}: HeaderProps) {
  return (
    <HeaderContainer>
      <StyledHeader>
        <Heading variant="heading5">
          Chat History
        </Heading>
      </StyledHeader>
      <StyledMenu>
        <TextButton
          startIcon={<LinePlusIcon />}
          size="medium"
          kind="tertiary"
          shape="square"
          onClick={onNewChatClick}
        >
          New chat
        </TextButton>
      </StyledMenu>
    </HeaderContainer>
  )
}

export default Header
